import styled from "styled-components";

import Box from "../../../layout/boxes/Box";

import { StyledAccordionTitleProps } from "./AccordionTitle.types";

export const StyledAccordionTitle = styled(Box)<StyledAccordionTitleProps>`
	display: flex;
	justify-content: space-between;
	padding: ${({ theme }) => `${theme.space.lg} 0`};
	gap: ${({ theme }) => theme.space.lg};
	cursor: pointer;
`;
